 document.addEventListener('DOMContentLoaded', function () {
      const container = document.querySelector('.product__description');
      const toggleBtn = container?.querySelector('.toggle-description');

      if (container && toggleBtn) {
        const children = Array.from(container.children).filter(el =>
          !el.classList.contains('toggle-description-wrapper') && el.tagName.toLowerCase() !== 'style'
        );

        // Masquer tout sauf le premier élément
        children.forEach((el, i) => {
          if (i !== 0) el.style.display = 'none';
        });

        let expanded = false;

        toggleBtn.addEventListener('click', () => {
          expanded = !expanded;

          children.forEach((el, i) => {
            if (i !== 0) el.style.display = expanded ? 'block' : 'none';
          });

          toggleBtn.classList.toggle('expanded', expanded);
          toggleBtn.querySelector('.label').textContent = expanded ? 'Fermer' : 'En savoir +';

          if (!expanded) {
            container.scrollIntoView({ behavior: 'smooth', block: 'start' });
          }
        });
      }
    });